import axios, {
  AxiosInstance,
  InternalAxiosRequestConfig,
  AxiosError,
} from "axios";
import { authClient } from "@lib/okta";
import { CONFIG } from "@lib/config";

export const apiClient: AxiosInstance = axios.create({
  baseURL: CONFIG.AI_ROUTER_API,
});

apiClient.interceptors.request.use(
  (config: InternalAxiosRequestConfig): Promise<InternalAxiosRequestConfig> => {
    try {
      const token = authClient.getAccessToken();
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
    } catch (error) {
      console.error("Error fetching token:", error);
    }
    return Promise.resolve(config);
  },
  (error: AxiosError) => {
    return Promise.reject(error);
  }
);
